const DayMaintenNotify = "MaintenNotifyDay";
const PowerMaintenNotify = "MaintenNotifyPower";
const PowerMaintenNotifySetting = "MaintenNotifyPowerSetting";

var allRoles = [];
var roleMap = {};
var colMap = ["Week", "Month", "Quanrter", "Year"];

export default {
    name: "Maintennotify",
    components: {},
    data() {
        return {
            items: [],
            roles: [],
            setting: {},
            currentItem: {
                Id: "",
                Start: "",
                End: "",
                Reserved: "",
                RoleID: "",
                Type: "",
                Peroid: "",
            },
            mlItemTitle: "",
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            this.items = await this.$api.getMaintenNotifys();
            allRoles = [
                {
                    Id: 1,
                    Name: "A",
                },
                {
                    Id: 2,
                    Name: "B",
                },
                {
                    Id: 3,
                    Name: "C",
                },
                {
                    Id: 4,
                    Name: "D",
                },
                {
                    Id: 5,
                    Name: "E",
                },
            ];
            var roles = await this.$api.getRoles();
            roles.filter(x=>x.Id > 5).forEach(r=> allRoles.push(r));
            this.roles = roles;
            var setting = await this.$api.getConfig(
                `${DayMaintenNotify},${PowerMaintenNotify},${PowerMaintenNotifySetting}`
            );
            if (setting[DayMaintenNotify]) {
                setting[DayMaintenNotify] = JSON.parse(
                    setting[DayMaintenNotify].Value
                );
            } else {
                setting[DayMaintenNotify] = {
                    Role: "SNT畫面提醒",
                    RoleID: -1,
                    Reserved: true,
                    WeekStart: -3,
                    WeekEnd: 3,
                    MonthStart: -7,
                    MonthEnd: 7,
                    QuanrterStart: -15,
                    QuanrterEnd: 15,
                    YearStart: -30,
                    YearEnd: 30,
                    WeekID: -1,
                    MonthID: -1,
                    QuanrterID: -1,
                    YearID: -1,
                    Type: -1,
                };
            }
            if (setting[PowerMaintenNotify]) {
                setting[PowerMaintenNotify] = JSON.parse(
                    setting[PowerMaintenNotify].Value
                );
            } else {
                setting[PowerMaintenNotify] = {
                    Role: "SNT畫面提醒",
                    RoleID: -1,
                    Reserved: true,
                    WeekStart: 90,
                    WeekEnd: 110,
                    MonthStart: 90,
                    MonthEnd: 110,
                    QuanrterStart: 90,
                    QuanrterEnd: 110,
                    YearStart: 90,
                    YearEnd: 110,
                    WeekID: -1,
                    MonthID: -1,
                    QuanrterID: -1,
                    YearID: -1,
                    WeekValue: 0,
                    MonthValue: 0,
                    QuanrterValue: 0,
                    YearValue: 0,
                    Type: -1,
                };
            }
            if (setting[PowerMaintenNotifySetting]) {
                setting[PowerMaintenNotifySetting] = JSON.parse(
                    setting[PowerMaintenNotifySetting].Value
                );
            } else {
                setting[PowerMaintenNotifySetting] = {
                    Role: "產能設定",
                    RoleID: -2,
                    Reserved: true,
                    WeekStart: -1,
                    WeekEnd: 3,
                    WeekID: -1,
                    MonthStart: 1,
                    MonthEnd: 1,
                    MonthID: -1,
                    QuanrterStart: 1,
                    QuanrterEnd: 1,
                    QuanrterID: -1,
                    YearStart: 1,
                    YearEnd: 1,
                    YearID: -1,
                    WeekValue: 0,
                    MonthValue: 0,
                    QuanrterValue: 0,
                    YearValue: 0,
                    Type: -1,
                };
            }
            console.log(setting);
            this.setting = setting;
            var list = this.items.groupBy("Type");

            this.roles.forEach((r) => (roleMap[r.Id] = r));

            this.createDayTable(list);
            this.createPowerTable(list);
        },
        createDayTable(list) {
            var cols = [
                {
                    title: "提醒群組", data: "Role", render(data, type, row, meta) {
                        var remove = (row["RoleID"] <= -1) ? '' : `<div class="btn-remove-circle" onclick="window.model.delItem(${row["RoleID"]})"></div>`;
                        return `<div class="d-flex">${remove}
                    <span>${data}</span>
                  </div>`;
                    }
                },
                {
                    title: "週保養",
                    data: "WeekStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["WeekStart"];
                        var end = row["WeekEnd"];
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;" ' +
                            ` onchange="window.model.update('Start', ${row["WeekID"]}, this, 'Day', 'Week')">` +
                            '        <option value="-3"' +
                            (start == -3 ? "selected" : "") +
                            ">D-3</option>" +
                            '        <option value="-2"' +
                            (start == -2 ? "selected" : "") +
                            ">D-2</option>" +
                            '        <option value="-1"' +
                            (start == -1 ? "selected" : "") +
                            ">D-1</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["WeekID"]}, this, 'Day', 'Week')">` +
                            '        <option value="1"' +
                            (end == 1 ? "selected" : "") +
                            ">D+1</option>" +
                            '        <option value="2"' +
                            (end == 2 ? "selected" : "") +
                            ">D+2</option>" +
                            '        <option value="3"' +
                            (end == 3 ? "selected" : "") +
                            ">D+3</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
                {
                    title: "月保養",
                    data: "MonthStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["MonthStart"];
                        var end = row["MonthEnd"];
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            ` onchange="window.model.update('Start', ${row["MonthID"]}, this, 'Day', 'Month')">` +
                            '        <option value="-7"' +
                            (start == -7 ? "selected" : "") +
                            ">D-7</option>" +
                            '        <option value="-6"' +
                            (start == -6 ? "selected" : "") +
                            ">D-6</option>" +
                            '        <option value="-5"' +
                            (start == -5 ? "selected" : "") +
                            ">D-5</option>" +
                            '        <option value="-4"' +
                            (start == -4 ? "selected" : "") +
                            ">D-4</option>" +
                            '        <option value="-3"' +
                            (start == -3 ? "selected" : "") +
                            ">D-3</option>" +
                            '        <option value="-2"' +
                            (start == -2 ? "selected" : "") +
                            ">D-2</option>" +
                            '        <option value="-1"' +
                            (start == -1 ? "selected" : "") +
                            ">D-1</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["MonthID"]}, this, 'Day', 'Month')">` +
                            '        <option value="1"' +
                            (end == 1 ? "selected" : "") +
                            ">D+1</option>" +
                            '        <option value="2"' +
                            (end == 2 ? "selected" : "") +
                            ">D+2</option>" +
                            '        <option value="3"' +
                            (end == 3 ? "selected" : "") +
                            ">D+3</option>" +
                            '        <option value="4"' +
                            (end == 4 ? "selected" : "") +
                            ">D+4</option>" +
                            '        <option value="5"' +
                            (end == 5 ? "selected" : "") +
                            ">D+5</option>" +
                            '        <option value="6"' +
                            (end == 6 ? "selected" : "") +
                            ">D+6</option>" +
                            '        <option value="7"' +
                            (end == 7 ? "selected" : "") +
                            ">D+7</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
                {
                    title: "季保養",
                    data: "QuanrterStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["QuanrterStart"];
                        var end = row["QuanrterEnd"];
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            ` onchange="window.model.update('Start', ${row["QuanrterID"]}, this, 'Day', 'Quanrter')">` +
                            '        <option value="-15"' +
                            (start == -15 ? "selected" : "") +
                            ">D-15</option>" +
                            '        <option value="-14"' +
                            (start == -14 ? "selected" : "") +
                            ">D-14</option>" +
                            '        <option value="-13"' +
                            (start == -13 ? "selected" : "") +
                            ">D-13</option>" +
                            '        <option value="-12"' +
                            (start == -12 ? "selected" : "") +
                            ">D-12</option>" +
                            '        <option value="-11"' +
                            (start == -11 ? "selected" : "") +
                            ">D-11</option>" +
                            '        <option value="-10"' +
                            (start == -10 ? "selected" : "") +
                            ">D-10</option>" +
                            '        <option value="-9"' +
                            (start == -9 ? "selected" : "") +
                            ">D-9</option>" +
                            '        <option value="-8"' +
                            (start == -8 ? "selected" : "") +
                            ">D-8</option>" +
                            '        <option value="-7"' +
                            (start == -7 ? "selected" : "") +
                            ">D-7</option>" +
                            '        <option value="-6"' +
                            (start == -6 ? "selected" : "") +
                            ">D-6</option>" +
                            '        <option value="-5"' +
                            (start == -5 ? "selected" : "") +
                            ">D-5</option>" +
                            '        <option value="-4"' +
                            (start == -4 ? "selected" : "") +
                            ">D-4</option>" +
                            '        <option value="-3"' +
                            (start == -3 ? "selected" : "") +
                            ">D-3</option>" +
                            '        <option value="-2"' +
                            (start == -2 ? "selected" : "") +
                            ">D-2</option>" +
                            '        <option value="-1"' +
                            (start == -1 ? "selected" : "") +
                            ">D-1</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["QuanrterID"]}, this, 'Day', 'Quanrter')">` +
                            '        <option value="1"' +
                            (end == 1 ? "selected" : "") +
                            ">D+1</option>" +
                            '        <option value="2"' +
                            (end == 2 ? "selected" : "") +
                            ">D+2</option>" +
                            '        <option value="3"' +
                            (end == 3 ? "selected" : "") +
                            ">D+3</option>" +
                            '        <option value="4"' +
                            (end == 4 ? "selected" : "") +
                            ">D+4</option>" +
                            '        <option value="5"' +
                            (end == 5 ? "selected" : "") +
                            ">D+5</option>" +
                            '        <option value="6"' +
                            (end == 6 ? "selected" : "") +
                            ">D+6</option>" +
                            '        <option value="7"' +
                            (end == 7 ? "selected" : "") +
                            ">D+7</option>" +
                            '        <option value="8"' +
                            (end == 8 ? "selected" : "") +
                            ">D+8</option>" +
                            '        <option value="9"' +
                            (end == 9 ? "selected" : "") +
                            ">D+9</option>" +
                            '        <option value="10"' +
                            (end == 10 ? "selected" : "") +
                            ">D+10</option>" +
                            '        <option value="11"' +
                            (end == 11 ? "selected" : "") +
                            ">D+11</option>" +
                            '        <option value="12"' +
                            (end == 12 ? "selected" : "") +
                            ">D+12</option>" +
                            '        <option value="13"' +
                            (end == 13 ? "selected" : "") +
                            ">D+13</option>" +
                            '        <option value="14"' +
                            (end == 14 ? "selected" : "") +
                            ">D+14</option>" +
                            '        <option value="15"' +
                            (end == 15 ? "selected" : "") +
                            ">D+15</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
                {
                    title: "年保養",
                    data: "YearStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["YearStart"];
                        var end = row["YearEnd"];
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            ` onchange="window.model.update('Start', ${row["YearID"]}, this, 'Day', 'Year')">` +
                            '        <option value="-30"' +
                            (start == -30 ? "selected" : "") +
                            ">D-30</option>" +
                            '        <option value="-29"' +
                            (start == -29 ? "selected" : "") +
                            ">D-29</option>" +
                            '        <option value="-28"' +
                            (start == -28 ? "selected" : "") +
                            ">D-28</option>" +
                            '        <option value="-27"' +
                            (start == -27 ? "selected" : "") +
                            ">D-27</option>" +
                            '        <option value="-26"' +
                            (start == -26 ? "selected" : "") +
                            ">D-26</option>" +
                            '        <option value="-25"' +
                            (start == -25 ? "selected" : "") +
                            ">D-25</option>" +
                            '        <option value="-24"' +
                            (start == -24 ? "selected" : "") +
                            ">D-24</option>" +
                            '        <option value="-23"' +
                            (start == -23 ? "selected" : "") +
                            ">D-23</option>" +
                            '        <option value="-22"' +
                            (start == -22 ? "selected" : "") +
                            ">D-22</option>" +
                            '        <option value="-21"' +
                            (start == -21 ? "selected" : "") +
                            ">D-21</option>" +
                            '        <option value="-20"' +
                            (start == -20 ? "selected" : "") +
                            ">D-20</option>" +
                            '        <option value="-19"' +
                            (start == -19 ? "selected" : "") +
                            ">D-19</option>" +
                            '        <option value="-18"' +
                            (start == -18 ? "selected" : "") +
                            ">D-18</option>" +
                            '        <option value="-17"' +
                            (start == -17 ? "selected" : "") +
                            ">D-17</option>" +
                            '        <option value="-16"' +
                            (start == -16 ? "selected" : "") +
                            ">D-16</option>" +
                            '        <option value="-15"' +
                            (start == -15 ? "selected" : "") +
                            ">D-15</option>" +
                            '        <option value="-14"' +
                            (start == -14 ? "selected" : "") +
                            ">D-14</option>" +
                            '        <option value="-13"' +
                            (start == -13 ? "selected" : "") +
                            ">D-13</option>" +
                            '        <option value="-12"' +
                            (start == -12 ? "selected" : "") +
                            ">D-12</option>" +
                            '        <option value="-11"' +
                            (start == -11 ? "selected" : "") +
                            ">D-11</option>" +
                            '        <option value="-10"' +
                            (start == -10 ? "selected" : "") +
                            ">D-10</option>" +
                            '        <option value="-9"' +
                            (start == -9 ? "selected" : "") +
                            ">D-9</option>" +
                            '        <option value="-8"' +
                            (start == -8 ? "selected" : "") +
                            ">D-8</option>" +
                            '        <option value="-7"' +
                            (start == -7 ? "selected" : "") +
                            ">D-7</option>" +
                            '        <option value="-6"' +
                            (start == -6 ? "selected" : "") +
                            ">D-6</option>" +
                            '        <option value="-5"' +
                            (start == -5 ? "selected" : "") +
                            ">D-5</option>" +
                            '        <option value="-4"' +
                            (start == -4 ? "selected" : "") +
                            ">D-4</option>" +
                            '        <option value="-3"' +
                            (start == -3 ? "selected" : "") +
                            ">D-3</option>" +
                            '        <option value="-2"' +
                            (start == -2 ? "selected" : "") +
                            ">D-2</option>" +
                            '        <option value="-1"' +
                            (start == -1 ? "selected" : "") +
                            ">D-1</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["YearID"]}, this, 'Day', 'Year')">` +
                            '        <option value="1"' +
                            (end == 1 ? "selected" : "") +
                            ">D+1</option>" +
                            '        <option value="2"' +
                            (end == 2 ? "selected" : "") +
                            ">D+2</option>" +
                            '        <option value="3"' +
                            (end == 3 ? "selected" : "") +
                            ">D+3</option>" +
                            '        <option value="4"' +
                            (end == 4 ? "selected" : "") +
                            ">D+4</option>" +
                            '        <option value="5"' +
                            (end == 5 ? "selected" : "") +
                            ">D+5</option>" +
                            '        <option value="6"' +
                            (end == 6 ? "selected" : "") +
                            ">D+6</option>" +
                            '        <option value="7"' +
                            (end == 7 ? "selected" : "") +
                            ">D+7</option>" +
                            '        <option value="8"' +
                            (end == 8 ? "selected" : "") +
                            ">D+8</option>" +
                            '        <option value="9"' +
                            (end == 9 ? "selected" : "") +
                            ">D+9</option>" +
                            '        <option value="10"' +
                            (end == 10 ? "selected" : "") +
                            ">D+10</option>" +
                            '        <option value="11"' +
                            (end == 11 ? "selected" : "") +
                            ">D+11</option>" +
                            '        <option value="12"' +
                            (end == 12 ? "selected" : "") +
                            ">D+12</option>" +
                            '        <option value="13"' +
                            (end == 13 ? "selected" : "") +
                            ">D+13</option>" +
                            '        <option value="14"' +
                            (end == 14 ? "selected" : "") +
                            ">D+14</option>" +
                            '        <option value="15"' +
                            (end == 15 ? "selected" : "") +
                            ">D+15</option>" +
                            '        <option value="16"' +
                            (end == 16 ? "selected" : "") +
                            ">D+16</option>" +
                            '        <option value="17"' +
                            (end == 17 ? "selected" : "") +
                            ">D+17</option>" +
                            '        <option value="18"' +
                            (end == 18 ? "selected" : "") +
                            ">D+18</option>" +
                            '        <option value="19"' +
                            (end == 19 ? "selected" : "") +
                            ">D+19</option>" +
                            '        <option value="20"' +
                            (end == 20 ? "selected" : "") +
                            ">D+20</option>" +
                            '        <option value="21"' +
                            (end == 21 ? "selected" : "") +
                            ">D+21</option>" +
                            '        <option value="22"' +
                            (end == 22 ? "selected" : "") +
                            ">D+22</option>" +
                            '        <option value="23"' +
                            (end == 23 ? "selected" : "") +
                            ">D+23</option>" +
                            '        <option value="24"' +
                            (end == 24 ? "selected" : "") +
                            ">D+24</option>" +
                            '        <option value="25"' +
                            (end == 25 ? "selected" : "") +
                            ">D+25</option>" +
                            '        <option value="26"' +
                            (end == 26 ? "selected" : "") +
                            ">D+26</option>" +
                            '        <option value="27"' +
                            (end == 27 ? "selected" : "") +
                            ">D+27</option>" +
                            '        <option value="28"' +
                            (end == 28 ? "selected" : "") +
                            ">D+28</option>" +
                            '        <option value="29"' +
                            (end == 29 ? "selected" : "") +
                            ">D+29</option>" +
                            '        <option value="30"' +
                            (end == 30 ? "selected" : "") +
                            ">D+30</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                }
            ];

            var dtData = [];
            dtData.push(this.setting[DayMaintenNotify]);
            console.log(dtData);
            if (list[0]) {
                var glst = list[0].groupBy("RoleID");
                for (var roleID in glst) {
                    var role = roleMap[roleID];
                    if (!role) continue;
                    var cs = glst[roleID].groupBy("Peroid");
                    dtData.push({
                        Role: role.Name,
                        RoleID: roleID,
                        Reserved: false,
                        WeekStart: cs[0][0].Start,
                        WeekEnd: cs[0][0].End,
                        WeekID: cs[0][0].Id,
                        MonthStart: cs[1][0].Start,
                        MonthEnd: cs[1][0].End,
                        MonthID: cs[1][0].Id,
                        QuanrterStart: cs[2][0].Start,
                        QuanrterEnd: cs[2][0].End,
                        QuanrterID: cs[2][0].Id,
                        YearStart: cs[3][0].Start,
                        YearEnd: cs[3][0].End,
                        YearID: cs[3][0].Id,
                        Type: 0,
                    });
                }
            }
            this.createDataTable("#tabDay", cols, dtData, {
                bSort: false, searching: false, paging: false, bInfo :false
            });
        },
        createPowerTable(list) {
            var cols = [
                {
                    title: "提醒群組", data: "Role", render(data, type, row, meta) {
                        var remove = (row["RoleID"] <= -1) ? '' : `<div class="btn-remove-circle" onclick="window.model.delItem(${row["RoleID"]})"></div>`;
                        return `<div class="d-flex">${remove}
                    <span>${data}</span>
                  </div>`;
                    }
                },
                {
                    title: "週保養",
                    data: "WeekStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["WeekStart"];
                        var end = row["WeekEnd"];
                        if (row["RoleID"] == -2) {
                            return `<input type="number" class="form-control no-border" style="width: 120px;display: inline-block;" value="${row["WeekValue"]}"
              onchange="window.model.updateValue(this, 'Week')"></input><span style="margin-left:10px;">單位</span>`;
                        }
                        console.log(start);
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;" ' +
                            ` onchange="window.model.update('Start', ${row["WeekID"]}, this, 'Power', 'Week')">` +
                            '        <option value="90"' +
                            (start == 90 ? "selected" : "") +
                            ">90%</option>" +
                            '        <option value="91"' +
                            (start == 91 ? "selected" : "") +
                            ">91%</option>" +
                            '        <option value="92"' +
                            (start == 92 ? "selected" : "") +
                            ">92%</option>" +
                            '        <option value="93"' +
                            (start == 93 ? "selected" : "") +
                            ">93%</option>" +
                            '        <option value="94"' +
                            (start == 94 ? "selected" : "") +
                            ">94%</option>" +
                            '        <option value="95"' +
                            (start == 95 ? "selected" : "") +
                            ">95%</option>" +
                            '        <option value="96"' +
                            (start == 96 ? "selected" : "") +
                            ">96%</option>" +
                            '        <option value="97"' +
                            (start == 97 ? "selected" : "") +
                            ">97%</option>" +
                            '        <option value="98"' +
                            (start == 98 ? "selected" : "") +
                            ">98%</option>" +
                            '        <option value="99"' +
                            (start == 99 ? "selected" : "") +
                            ">99%</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["WeekID"]}, this, 'Power', 'Week')">` +
                            '        <option value="101"' +
                            (end == 101 ? "selected" : "") +
                            ">101%</option>" +
                            '        <option value="102"' +
                            (end == 102 ? "selected" : "") +
                            ">102%</option>" +
                            '        <option value="103"' +
                            (end == 103 ? "selected" : "") +
                            ">103%</option>" +
                            '        <option value="104"' +
                            (end == 104 ? "selected" : "") +
                            ">104%</option>" +
                            '        <option value="105"' +
                            (end == 105 ? "selected" : "") +
                            ">105%</option>" +
                            '        <option value="106"' +
                            (end == 106 ? "selected" : "") +
                            ">106%</option>" +
                            '        <option value="107"' +
                            (end == 107 ? "selected" : "") +
                            ">107%</option>" +
                            '        <option value="108"' +
                            (end == 108 ? "selected" : "") +
                            ">108%</option>" +
                            '        <option value="109"' +
                            (end == 109 ? "selected" : "") +
                            ">109%</option>" +
                            '        <option value="110"' +
                            (end == 110 ? "selected" : "") +
                            ">110%</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
                {
                    title: "月保養",
                    data: "MonthStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["MonthStart"];
                        var end = row["MonthEnd"];
                        if (row["RoleID"] == -2) {
                            return `<input type="number" class="form-control no-border" style="width: 120px;display: inline-block;" value="${row["MonthValue"]}"
              onchange="window.model.updateValue(this, 'Month')"></input><span style="margin-left:10px;">單位</span>`;
                        }
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            ` onchange="window.model.update('Start', ${row["MonthID"]}, this, 'Power', 'Month')">` +
                            '        <option value="90"' +
                            (start == 90 ? "selected" : "") +
                            ">90%</option>" +
                            '        <option value="91"' +
                            (start == 91 ? "selected" : "") +
                            ">91%</option>" +
                            '        <option value="92"' +
                            (start == 92 ? "selected" : "") +
                            ">92%</option>" +
                            '        <option value="93"' +
                            (start == 93 ? "selected" : "") +
                            ">93%</option>" +
                            '        <option value="94"' +
                            (start == 94 ? "selected" : "") +
                            ">94%</option>" +
                            '        <option value="95"' +
                            (start == 95 ? "selected" : "") +
                            ">95%</option>" +
                            '        <option value="96"' +
                            (start == 96 ? "selected" : "") +
                            ">96%</option>" +
                            '        <option value="97"' +
                            (start == 97 ? "selected" : "") +
                            ">97%</option>" +
                            '        <option value="98"' +
                            (start == 98 ? "selected" : "") +
                            ">98%</option>" +
                            '        <option value="99"' +
                            (start == 99 ? "selected" : "") +
                            ">99%</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["MonthID"]}, this, 'Power', 'Month')">` +
                            '        <option value="101"' +
                            (end == 101 ? "selected" : "") +
                            ">101%</option>" +
                            '        <option value="102"' +
                            (end == 102 ? "selected" : "") +
                            ">102%</option>" +
                            '        <option value="103"' +
                            (end == 103 ? "selected" : "") +
                            ">103%</option>" +
                            '        <option value="104"' +
                            (end == 104 ? "selected" : "") +
                            ">104%</option>" +
                            '        <option value="105"' +
                            (end == 105 ? "selected" : "") +
                            ">105%</option>" +
                            '        <option value="106"' +
                            (end == 106 ? "selected" : "") +
                            ">106%</option>" +
                            '        <option value="107"' +
                            (end == 107 ? "selected" : "") +
                            ">107%</option>" +
                            '        <option value="108"' +
                            (end == 108 ? "selected" : "") +
                            ">108%</option>" +
                            '        <option value="109"' +
                            (end == 109 ? "selected" : "") +
                            ">109%</option>" +
                            '        <option value="110"' +
                            (end == 110 ? "selected" : "") +
                            ">110%</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
                {
                    title: "季保養",
                    data: "QuanrterStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["QuanrterStart"];
                        var end = row["QuanrterEnd"];
                        if (row["RoleID"] == -2) {
                            return `<input type="number" class="form-control no-border" style="width: 120px;display: inline-block;" value="${row["QuanrterValue"]}"
              onchange="window.model.updateValue(this, 'Quanrter')"></input><span style="margin-left:10px;">單位</span>`;
                        }
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            ` onchange="window.model.update('Start', ${row["QuanrterID"]}, this, 'Power', 'Quanrter')">` +
                            '        <option value="90"' +
                            (start == 90 ? "selected" : "") +
                            ">90%</option>" +
                            '        <option value="91"' +
                            (start == 91 ? "selected" : "") +
                            ">91%</option>" +
                            '        <option value="92"' +
                            (start == 92 ? "selected" : "") +
                            ">92%</option>" +
                            '        <option value="93"' +
                            (start == 93 ? "selected" : "") +
                            ">93%</option>" +
                            '        <option value="94"' +
                            (start == 94 ? "selected" : "") +
                            ">94%</option>" +
                            '        <option value="95"' +
                            (start == 95 ? "selected" : "") +
                            ">95%</option>" +
                            '        <option value="96"' +
                            (start == 96 ? "selected" : "") +
                            ">96%</option>" +
                            '        <option value="97"' +
                            (start == 97 ? "selected" : "") +
                            ">97%</option>" +
                            '        <option value="98"' +
                            (start == 98 ? "selected" : "") +
                            ">98%</option>" +
                            '        <option value="99"' +
                            (start == 99 ? "selected" : "") +
                            ">99%</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["QuanrterID"]}, this, 'Power', 'Quanrter')">` +
                            '        <option value="101"' +
                            (end == 101 ? "selected" : "") +
                            ">101%</option>" +
                            '        <option value="102"' +
                            (end == 102 ? "selected" : "") +
                            ">102%</option>" +
                            '        <option value="103"' +
                            (end == 103 ? "selected" : "") +
                            ">103%</option>" +
                            '        <option value="104"' +
                            (end == 104 ? "selected" : "") +
                            ">104%</option>" +
                            '        <option value="105"' +
                            (end == 105 ? "selected" : "") +
                            ">105%</option>" +
                            '        <option value="106"' +
                            (end == 106 ? "selected" : "") +
                            ">106%</option>" +
                            '        <option value="107"' +
                            (end == 107 ? "selected" : "") +
                            ">107%</option>" +
                            '        <option value="108"' +
                            (end == 108 ? "selected" : "") +
                            ">108%</option>" +
                            '        <option value="109"' +
                            (end == 109 ? "selected" : "") +
                            ">109%</option>" +
                            '        <option value="110"' +
                            (end == 110 ? "selected" : "") +
                            ">110%</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
                {
                    title: "年保養",
                    data: "YearStart",
                    className: "tac",
                    render: function (data, type, row, meta) {
                        var start = row["YearStart"];
                        var end = row["YearEnd"];
                        if (row["RoleID"] == -2) {
                            return `<input type="number" class="form-control no-border" style="width: 120px;display: inline-block;" value="${row["YearValue"]}"
              onchange="window.model.updateValue(this, 'Year')"></input><span style="margin-left:10px;">單位</span>`;
                        }
                        return (
                            '    <select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            ` onchange="window.model.update('Start', ${row["YearID"]}, this, 'Power', 'Year')">` +
                            '        <option value="90"' +
                            (start == 90 ? "selected" : "") +
                            ">90%</option>" +
                            '        <option value="91"' +
                            (start == 91 ? "selected" : "") +
                            ">91%</option>" +
                            '        <option value="92"' +
                            (start == 92 ? "selected" : "") +
                            ">92%</option>" +
                            '        <option value="93"' +
                            (start == 93 ? "selected" : "") +
                            ">93%</option>" +
                            '        <option value="94"' +
                            (start == 94 ? "selected" : "") +
                            ">94%</option>" +
                            '        <option value="95"' +
                            (start == 95 ? "selected" : "") +
                            ">95%</option>" +
                            '        <option value="96"' +
                            (start == 96 ? "selected" : "") +
                            ">96%</option>" +
                            '        <option value="97"' +
                            (start == 97 ? "selected" : "") +
                            ">97%</option>" +
                            '        <option value="98"' +
                            (start == 98 ? "selected" : "") +
                            ">98%</option>" +
                            '        <option value="99"' +
                            (start == 99 ? "selected" : "") +
                            ">99%</option>" +
                            '        <option value="0"' +
                            (start == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            '    </select><span style="' +
                            "    display: inline-block;" +
                            "    margin-left: 5px;" +
                            "    margin-right: 5px;" +
                            '">到</span><select class="form-control no-border" style="width: 95px;display: inline-block;"' +
                            //(start == 0 ? "disabled" : "") +
                            ` onchange="window.model.update('End', ${row["YearID"]}, this, 'Power', 'Year')">` +
                            '        <option value="101"' +
                            (end == 101 ? "selected" : "") +
                            ">101%</option>" +
                            '        <option value="102"' +
                            (end == 102 ? "selected" : "") +
                            ">102%</option>" +
                            '        <option value="103"' +
                            (end == 103 ? "selected" : "") +
                            ">103%</option>" +
                            '        <option value="104"' +
                            (end == 104 ? "selected" : "") +
                            ">104%</option>" +
                            '        <option value="105"' +
                            (end == 105 ? "selected" : "") +
                            ">105%</option>" +
                            '        <option value="106"' +
                            (end == 106 ? "selected" : "") +
                            ">106%</option>" +
                            '        <option value="107"' +
                            (end == 107 ? "selected" : "") +
                            ">107%</option>" +
                            '        <option value="108"' +
                            (end == 108 ? "selected" : "") +
                            ">108%</option>" +
                            '        <option value="109"' +
                            (end == 109 ? "selected" : "") +
                            ">109%</option>" +
                            '        <option value="110"' +
                            (end == 110 ? "selected" : "") +
                            ">110%</option>" +
                            '        <option value="0"' +
                            (end == 0 ? "selected" : "") +
                            ">不提醒</option>" +
                            "    </select>"
                        );
                    },
                },
            ];

            var dtData = [];
            dtData.push(this.setting[PowerMaintenNotifySetting]);
            dtData.push(this.setting[PowerMaintenNotify]);
            if (list[1]) {
                var glst = list[1].groupBy("RoleID");
                for (var roleID in glst) {
                    var role = roleMap[roleID];
                    var cs = glst[roleID].groupBy("Peroid");
                    dtData.push({
                        Role: role.Name,
                        RoleID: roleID,
                        Reserved: false,
                        WeekStart: cs[0][0].Start,
                        WeekEnd: cs[0][0].End,
                        WeekID: cs[0][0].Id,
                        MonthStart: cs[1][0].Start,
                        MonthEnd: cs[1][0].End,
                        MonthID: cs[1][0].Id,
                        QuanrterStart: cs[2][0].Start,
                        QuanrterEnd: cs[2][0].End,
                        QuanrterID: cs[2][0].Id,
                        YearStart: cs[3][0].Start,
                        YearEnd: cs[3][0].End,
                        YearID: cs[3][0].Id,
                        WeekValue: 0,
                        MonthValue: 0,
                        QuanrterValue: 0,
                        YearValue: 0,
                        Type: 0,
                    });
                }
            }
            this.createDataTable("#tabPower", cols, dtData, {
                bSort: false, searching: false, paging: false, bInfo :false
            });
        },
        onSelected() {
            this.load();
        },
        showAdd() {
            this.mlItemTitle = "新增";
            this.currentItem = {
                RoleID: -1,
            };
            this.roles = [];
            var map = {};
            this.items.forEach((x) => (map[x.RoleID] = true));
            console.log(map);
            allRoles.forEach((r) => {
                if (!map[r.Id]) {
                    this.roles.push(r);
                }
            });
            console.log(allRoles);
            this.$bvModal.show("mlItem");
        },
        async editItem(id) {
            this.mlItemTitle = "修改";
            this.currentItem = await this.$api.getMaintennotify(id);
            this.$bvModal.show("mlItem");
        },
        async delItem(id) {
            var role = roleMap[id];
            if (this.currentItem) {
                this.confirm("請問要刪除：" + role.Name, async (r) => {
                    await this.$api.deleteMaintenNotify(id);
                    this.load();
                });
            }
        },
        async mlDialogOK(e) {
            e.preventDefault();
            if (!this.validate("#mlItem")) {
                return;
            }
            try {
                if (this.currentItem.Id) {
                    await this.$api.updateMaintennotify(this.currentItem);
                } else {
                    this.currentItem.Id = await this.$api.createMaintenNotify(
                        this.currentItem
                    );
                }
                this.$bvModal.hide("mlItem");
                this.load();
            } catch (ex) {
                console.log(ex);
            }
            return;
        },
        async update(property, id, e, type, peroid) {
            this.currentItem = null;
            this.items.forEach((r) => {
                if (r.Id == id) {
                    this.currentItem = r;
                }
            });
            var val = $(e).val();
            if (this.currentItem) {
                this.currentItem[property] = val;
                await this.$api.updateMaintenNotify(this.currentItem);
                this.load();
            } else {
                var key = type == "Day" ? DayMaintenNotify : PowerMaintenNotify;
                this.setting[key][peroid + property] = val;
                await this.$api.updateConfig({
                    Key: key,
                    Value: JSON.stringify(this.setting[key]),
                });
                this.load();
            }
        },
        async updateValue(e, property) {
            //_.debounce(async () => {
            var val = $(e).val();
            this.setting[PowerMaintenNotifySetting][property + "Value"] = val;
            await this.$api.updateConfig({
                Key: PowerMaintenNotifySetting,
                Value: JSON.stringify(this.setting[PowerMaintenNotifySetting]),
            });
            this.load();
            //});
        },
    },
};